// ─────────────────────────────────────────────
//  TabBar.jsx — Dock flotante estilo iOS (Safari)
//  Pill principal (5 secciones) + botón de ajustes
// ─────────────────────────────────────────────

import React from 'react';
import styles from './TabBar.module.css';

export const SETTINGS_TAB_ID = 'ajustes';

const TABS = [
	{ id: 'tips',        label: 'Propina',    icon: '💸', accent: '#0cbdb1' },
	{ id: 'porcentajes', label: 'Porcentaje', icon: '🏷️', accent: '#f08400' },
	{ id: 'comparar',    label: 'Comparar',    icon: '↔️', accent: '#30D158' },
	{ id: 'peso',        label: 'Peso',        icon: '⚖️', accent: '#dc0184' },
	{ id: 'inversion',   label: 'Inversión',   icon: '📈', accent: '#007AFF' },
];

const SETTINGS_ACCENT = '#8e8e93';

export default function TabBar({ activeTab, onTabChange }) {
	const isSettingsActive = activeTab === SETTINGS_TAB_ID;

	return (
		<div className={styles.dock} aria-hidden={false}>
			<nav className={styles.pill} aria-label="Navegación principal">
				{TABS.map((tab) => {
					const isActive = activeTab === tab.id;
					return (
						<button
							key={tab.id}
							type="button"
							className={`${styles.tab} ${isActive ? styles.active : ''}`}
							style={isActive ? { '--tab-accent': tab.accent } : undefined}
							onClick={() => onTabChange(tab.id)}
							aria-current={isActive ? 'page' : undefined}
							aria-label={tab.label}
						>
							<span className={styles.tabInner}>
								<span className={styles.icon} aria-hidden="true">{tab.icon}</span>
								<span className={styles.label}>{tab.label}</span>
							</span>
						</button>
					);
				})}
			</nav>

			<button
				type="button"
				className={`${styles.settingsPill} ${isSettingsActive ? styles.settingsActive : ''}`}
				style={isSettingsActive ? { '--tab-accent': SETTINGS_ACCENT } : undefined}
				onClick={() => onTabChange(SETTINGS_TAB_ID)}
				aria-current={isSettingsActive ? 'page' : undefined}
				aria-label="Ajustes"
			>
				<span className={styles.settingsIcon} aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings-icon lucide-settings"><path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"/><circle cx="12" cy="12" r="3"/></svg></span>
			</button>
		</div>
	);
}
